import { useMemo, useCallback } from 'react';
import { useFoldersStore } from '@/state/folders.state';
import { useGetFolderContents } from '@/queries/useFolders';
import { FolderScope } from '@/enums/folder-scope.enum';
import { buildFolderPath } from '@/utils/folder.utils';

export const useWorkspaceFolders = () => {
  const { data, isLoading, isError, refetch } = useGetFolderContents(FolderScope.WORKSPACE);

  const currentFolderId = useFoldersStore((state) => state.workspace.currentFolderId);
  const setCurrentFolderId = useFoldersStore((state) => state.setCurrentFolderId);

  const folders = useMemo(() => data?.folders ?? [], [data?.folders]);
  const recipes = useMemo(() => data?.recipes ?? [], [data?.recipes]);

  const folderPath = useMemo(() => buildFolderPath(currentFolderId, folders), [currentFolderId, folders]);

  const navigateToFolder = useCallback(
    (folderId?: string | null) => {
      setCurrentFolderId(folderId ?? null, FolderScope.WORKSPACE);
    },
    [setCurrentFolderId],
  );

  return {
    folders,
    recipes,
    currentFolderId,
    folderPath,
    navigateToFolder,
    isLoading,
    isError,
    refetch,
  };
};
